module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "elementHistoryModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content msm-form-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.elementId) ? _c('label', {
    staticClass: "control-label nopadding"
  }, [_vm._v("ID: " + _vm._s(_vm.elementId))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "element-history-modal-content"
  }, [(_vm.history.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.HIS000) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.HIS001) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.history), function(entry) {
    return _c('tr', {
      key: entry.SurveyInstanceHistoryGuid
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(entry.EntryCreatedByDisplayName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "entry-creation-timestamp"
    }, [_vm._v(_vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(
      entry.EntryCreatedAt
    )))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(entry.Message))])])
  }), 0)]) : _c('span', [_vm._v(_vm._s(_vm.lang.HIS002))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "grid-area": "left"
    }
  }, [(_vm.showExportButton) ? _c('button', {
    staticClass: "btn btn-raised btn-light",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.exportSurveyInstance
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.HIS011) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "grid-area": "right",
      "box-sizing": "border-box"
    }
  }, [_c('button', {
    staticClass: "btn btn-raised btn-light",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.HIS003) + "\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67d76aeb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/Dialogs/ElementHistoryModal.vue
// module id = 628
// module chunks = 1 2